<template>
	<div>
		<div class="row">
			<div>
				<input-select
					class="col-xs-12 col-sm-3 form-group"
					:label="'* ' + _traducao('global', 'unidadeDeArmazenamentoDeOrigem')"
					:opcoes-objeto="unidadesArmazenamento"
					v-model="form.id_unidade_armazenamento"
					@change="unidadeSelecionada"
					:mensagem-erro="form.erro.origem_abastecimento"
				/>
			</div>
			<div class="col-xs-12 col-sm-3 form-group">
				<label
					>{{
						_traducao('global', 'volumeAtualMovimentacaoCombustivel')
					}}:</label
				>
				<input
					v-model="form.unidadeArmazenamentoSelecionada.quantidade_atual"
					class="form-control"
					disabled
				/>
			</div>
			<div class="col-xs-12 col-sm-3 form-group">
				<label>{{ _traducao('global', 'combustivel') }}:</label>
				<input
					v-model="form.unidadeArmazenamentoSelecionada.descricao_combustivel"
					class="form-control"
					disabled
				/>
			</div>
			<div class="col-xs-12 col-sm-3 form-group">
				<label
					>{{
						_traducao('global', 'capacidadeMaximaMovimentacaoCombustivel')
					}}:</label
				>
				<input v-model="aeronave.tanque" class="form-control" disabled />
			</div>
		</div>
		<div class="row">
			<div
				class="col-xs-12 col-sm-3 form-group"
				:class="{'has-error': form.erro.volume != null}"
			>
				<label>* {{ _traducao('global', 'volume') }}:</label>
				<money
					v-model="form.volume"
					v-bind="_vpercem(1)"
					class="form-control text-right input-sm"
				/>
				<p class="help-block" v-if="form.erro.volume != null">
					{{ form.erro.volume }}
				</p>
			</div>
			<div class="col-xs-12 col-sm-3 form-group">
				<div class="input-group">
					<input-select
						:label="campoOrgao ? campoOrgao : _traducao('global', 'orgaos')"
						:opcoes-objeto="orgaos"
						v-model="form.id_orgao"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {isObject} from 'lodash'

export default {
	name: 'MovimentacaoAua',
	props: {
		aeronave: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		campoOrgao: {
			type: String,
			required: false,
			default: null
		},
		movimentacao: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		orgaos: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		unidadesArmazenamento: {
			default() {
				return []
			},
			type: Array,
			required: true
		}
	},
	data() {
		return {
			form: {}
		}
	},
	watch: {
		movimentacao: {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.form = this.movimentacao
				}
			}
		}
	},
	methods: {
		unidadeSelecionada(id) {
			this.$emit('seleciona-unidade-armazenamento', id)
		},

		async validadorFormAbastecimentoAua(index) {
			if (await this.validaMovimentacaoAua()) {
				this.$emit('abastecimento-aua-valido', this.form, index)
			} else {
				this.$emit('abastecimento-aua-invalido', false)
			}
		},

		async validaMovimentacaoAua() {
			var passou = true
			var obrigatorio = this._traducao('global', 'obrigacao')

			if (this.form.id_unidade_armazenamento == null) {
				this.form.erro.origem_abastecimento = obrigatorio
				passou = false
			} else {
				this.form.erro.origem_abastecimento = null
			}
			if (this.form.volume <= 0) {
				this.form.erro.volume = obrigatorio
				passou = false
			} else if (
				parseFloat(this.form.volume - this.form.volumeAntesEdicao) >
					parseFloat(
						this.form.unidadeArmazenamentoSelecionada.quantidade_atual
					) &&
				this.form.unidadeArmazenamentoAntesEdicao ==
					this.form.unidadeArmazenamentoSelecionada.id
			) {
				this.form.erro.volume = this._traducao(
					'global',
					'volumeMaiorQueDisponivelUa'
				)
				passou = false
			} else if (
				parseFloat(this.form.volume) >
					parseFloat(
						this.form.unidadeArmazenamentoSelecionada.quantidade_atual
					) &&
				this.form.unidadeArmazenamentoAntesEdicao !=
					this.form.unidadeArmazenamentoSelecionada.id
			) {
				this.form.erro.volume = this._traducao(
					'global',
					'volumeMaiorQueDisponivelUa'
				)
				passou = false
			} else if (this.form.volume > this.aeronave.tanque) {
				this.form.erro.volume = this._traducao(
					'global',
					'volumeMaiorQueTanqueAeronave'
				)
				passou = false
			} else {
				this.form.erro.volume = null
			}
			return passou
		}
	}
}
</script>

<style scoped></style>